/**
 * Consent-gated loaders for the third-party tags that used to sit inline in
 * index.html. Nothing here runs until the consent layer decides it may, so no
 * analytics/marketing cookies are set before the visitor has consented (in the
 * EEA/UK) or by default (elsewhere).
 *
 * IDs mirror the originals:
 *   - Google Tag Manager container: GTM-PL4XXC77
 *   - Google Analytics 4 property:  G-PZ6KM253DJ
 *   - Meta Pixel:                   1534295808397386
 */

const GTM_CONTAINER_ID = 'GTM-PL4XXC77';
const GA4_MEASUREMENT_ID = 'G-PZ6KM253DJ';
const META_PIXEL_ID = '1534295808397386';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    fbq?: ((...args: unknown[]) => void) & { callMethod?: (...args: unknown[]) => void };
    _fbq?: unknown;
  }
}

let analyticsLoaded = false;
let marketingLoaded = false;

/** Google Tag Manager + Google Analytics 4 (the "analytics" category). */
export function loadAnalyticsTags(): void {
  if (analyticsLoaded || typeof document === 'undefined') return;
  analyticsLoaded = true;

  // Google Tag Manager
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  const gtm = document.createElement('script');
  gtm.async = true;
  gtm.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}`;
  document.head.appendChild(gtm);

  // Google Analytics 4 (gtag.js)
  const gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
  document.head.appendChild(gtagScript);

  function gtag(...args: unknown[]) {
    window.dataLayer?.push(args);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA4_MEASUREMENT_ID);
}

/** Meta Pixel (the "marketing" category). */
export function loadMarketingTags(): void {
  if (marketingLoaded || typeof document === 'undefined') return;
  marketingLoaded = true;

  /* eslint-disable */
  // Standard Meta Pixel bootstrap, unrolled from the vendor one-liner.
  (function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return;
    const n: any = (f.fbq = function (...args: unknown[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    });
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = b.createElement(e) as HTMLScriptElement;
    t.async = true;
    t.src = v;
    const s = b.getElementsByTagName(e)[0];
    s.parentNode?.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq?.('init', META_PIXEL_ID);
  window.fbq?.('track', 'PageView');
}
